<template>
  <v-list-tile avatar style="padding: 0 0 12px">
    <v-list-tile-avatar size="24px" class="avatar-style">
      <v-img :src="user.profile_image ? `${$storage}/user/profile/${user.profile_image}` : profileImageSrc"></v-img>
    </v-list-tile-avatar>

    <v-list-tile-content>
      <v-list-tile-title class="user-name" v-text="user.name"></v-list-tile-title>
      <v-list-tile-title class="body-2" v-html="linkedContents"></v-list-tile-title>
      <div class="d-flex">
        <span class="user-actions pr-1">{{ published }}</span>

        <span class="user-actions">&bullet;</span>
        <v-btn @click="like({ idx })"
               small flat
               :color="likes ? 'primary' : ''"
               class="py-0 px-1 ma-0 user-actions"
               style="height: auto; min-width: 0; color: #cdcdcd;">
          {{ likeText }}
        </v-btn>

        <span class="user-actions">&bullet;</span>
        <v-btn @click="comment({ commentIdx, idx, commentUserName: user.name })"
               small flat
               class="py-0 px-1 ma-0 user-actions"
               style="height: auto; min-width: 0; color: #cdcdcd;">
          댓글달기
        </v-btn>

        <span class="user-actions">&bullet;</span>

        <v-btn v-if="userIdx === user.idx"
               @click="remove({ commentIdx, idx })"
               small flat
               class="py-0 px-1 ma-0 user-actions"
               style="height: auto; min-width: 0; color: #cdcdcd;">
          삭제
        </v-btn>
        <v-btn v-else
               @click="report({ commentIdx, idx })"
               small flat
               class="py-0 ma-0 user-actions"
               style="height: auto; min-width: 0; color: #cdcdcd;">
          신고
        </v-btn>

      </div>

      <v-list v-if="typeof recomments !== 'undefined' && recomments.length" style="padding: 12px 0 0; width: 100%;">
        <CommentListTile v-for="(recomment, index) of recomments" :key="index"
                         :idx="recomment.idx"
                         :postIdx="postIdx"
                         :commentIdx="typeof recomment.comment_idx !== 'undefined' ? recomment.comment_idx : recomment.talk_idx"
                         :createdAt="recomment.created_at"
                         :updatedAt="recomment.updated_at"
                         :contents="recomment.contents"
                         :likeCnt="recomment.like_cnt"
                         :likes="recomment.likes"
                         :user="recomment.user"
                         @like="like({ commentIdx: typeof recomment.comment_idx !== 'undefined' ? recomment.comment_idx : recomment.talk_idx, idx: recomment.idx })"
                         @comment="comment({ commentIdx: typeof recomment.comment_idx !== 'undefined' ? recomment.comment_idx : recomment.talk_idx, idx: recomment.idx, commentUserName: recomment.user.name })"
                         @report="report({ commentIdx: typeof recomment.comment_idx !== 'undefined' ? recomment.comment_idx : recomment.talk_idx, idx: recomment.idx })"
                         @remove="remove({ commentIdx: typeof recomment.comment_idx !== 'undefined' ? recomment.comment_idx : recomment.talk_idx, idx: recomment.idx })" />
        <v-btn small flat class="mr-0 my-0 pa-0"
               v-if="recommentCnt > recomments.length"
               @click="moreRecomment(idx)"
               style="margin-left: 34px; font-size: 12px; font-weight: 700; color: #707070; letter-spacing: -0.2px">
          답글 {{ recommentCnt - recomments.length }}개 더보기
        </v-btn>
      </v-list>
    </v-list-tile-content>

  </v-list-tile>
</template>

<script>
  import { mapGetters } from 'vuex';
  import { timeToDotString, urlToLink } from '@/util/util';

  export default {
    name: 'CommentListTile',
    props: [ 'idx', 'postIdx', 'commentIdx', 'createdAt', 'updatedAt', 'contents', 'likeCnt', 'likes', 'user', 'recommentCnt', 'recomments' ],
    computed: {
      ...mapGetters([ 'now' ]),
      ...mapGetters('user', { userIdx: 'idx' }),
      profileImageSrc () {
        return require('@/assets/img/profile-default.png');
      },
      likeText () {
        return this.likeCnt > 0 ? `${this.likeCnt} 좋아요` : '좋아요';
      },
      published () {
        return timeToDotString(this.createdAt, this.updatedAt, this.now);
      },
      linkedContents () {
        return urlToLink(this.contents);
      },
      recommentMaxPage () {
        return Math.ceil(this.recommentCnt / 5);
      }
    },
    data () {
      return {
        recommentOffset: 1
      };
    },
    methods: {
      like ({ commentIdx, idx }) {
        if (this.userIdx === 0) this.$router.replace({ name: 'SocialLogin', query: { redirect: this.$route.path }});
        else this.$emit('like', { postIdx: this.postIdx, commentIdx, idx });
      },
      comment ({ commentIdx, idx, commentUserName }) {
        if (this.userIdx === 0) this.$router.replace({ name: 'SocialLogin', query: { redirect: this.$route.path }});
        else this.$emit('comment', { postIdx: this.postIdx, commentIdx, idx, commentUserName });
      },
      report ({ commentIdx, idx }) {
        if (this.userIdx === 0) this.$router.replace({ name: 'SocialLogin', query: { redirect: this.$route.path }});
        else this.$emit('report', { postIdx: this.postIdx, commentIdx, idx });
      },
      remove ({ commentIdx, idx }) {
        this.$emit('remove', { postIdx: this.postIdx, commentIdx, idx });
      },
      moreRecomment (commentIdx) {
        if (this.userIdx === 0) {
          this.$router.replace({ name: 'SocialLogin', query: { redirect: this.$route.path }});
        } else {
          this.$emit('moreRecomment', { postIdx: this.postIdx, commentIdx, recommentOffset: this.recommentOffset, recommentCnt: this.recommentCnt });
          this.recommentOffset += 5;
        }
      },
    }
  }
</script>

<style lang="scss" scoped>
  /deep/ .v-list__tile {
    /*min-height: 82px;*/
    height: auto;

    padding: 0;
    align-items: flex-start;
  }

  .avatar-style {
    min-width: 0;
    padding-top: 12px;
    padding-right: 16px;
    flex-grow: 0;
    flex-shrink: 0;
  }

  .body-2 {
    height: auto;
    white-space: pre-wrap;
    word-break: keep-all;
    word-wrap: break-word;
  }

  .user-name {
    padding-top: 12px;
    height: auto;
    font-size: 10px;
    /*font-weight: 700;*/
    line-height: 14px;
    letter-spacing: -0.2px;
    color: map_get($colors, brownish-grey);
  }

  .user-actions {
    font-size: 12px;
    color: #cdcdcd;
    &:first-child {
      padding-left: 0;
    }
    &:nth-child(2n) {
      padding: 0;
    }
  }
</style>
